var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58.38287mm",
    height: "17.179489mm",
    viewBox: "0 0 58.38287 17.17949",
    id: "svg1092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1086"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1063",
    transform: "translate(-10.347248,0.57484712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2304",
    transform: "matrix(0.14533662,0,0,-0.14321007,27.67527,15.618596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -3.237,-0.726 -6.479,-1.275 -9.718,-1.275 -9.71,0 -19.421,4.917 -29.129,4.917 -9.723,0 -19.438,-4.917 -29.146,-4.917 -9.709,0 -19.42,4.917 -29.131,4.917 -10.415,0 -19.417,-4.917 -19.417,-4.917 v 65.092 c 0,0 9.707,4.92 19.417,4.92 9.711,0 19.422,-4.92 29.131,-4.92 9.708,0 19.369,4.916 29.133,4.92 9.773,-0.003 19.434,-4.92 29.142,-4.92 3.251,0 6.45,0.557 9.699,1.289 z",
    style: {
      fill: "#006bb5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2306"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2308",
    transform: "matrix(0.14533662,0,0,-0.14321007,27.67527,7.7045635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -3.237,-0.729 -6.479,-1.275 -9.718,-1.275 -9.71,0 -19.421,4.917 -29.129,4.917 h -0.013 c -9.71,0 -19.425,-4.917 -29.133,-4.917 -9.709,0 -19.42,4.917 -29.131,4.917 -10.415,0 -19.417,-4.917 -19.417,-4.917 v 9.831 c 0,0 9.707,4.92 19.417,4.92 9.711,0 19.422,-4.92 29.131,-4.92 9.708,0 19.369,4.916 29.133,4.92 9.773,-0.003 19.434,-4.92 29.142,-4.92 3.251,0 6.45,0.556 9.699,1.289 z",
    style: {
      fill: "#1b1768",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2310"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2312",
    transform: "matrix(0.14533662,0,0,-0.14321007,27.67527,10.342751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -3.237,-0.728 -6.479,-1.275 -9.718,-1.275 -9.71,0 -19.421,4.92 -29.129,4.92 h -0.013 c -9.71,0 -19.425,-4.92 -29.133,-4.92 -9.709,0 -19.42,4.92 -29.131,4.92 -10.415,0 -19.417,-4.92 -19.417,-4.92 v 9.834 c 0,0 9.707,4.918 19.417,4.918 9.711,0 19.422,-4.918 29.131,-4.918 9.708,0 19.369,4.913 29.133,4.918 9.773,-0.005 19.434,-4.918 29.142,-4.918 3.251,0 6.45,0.554 9.699,1.289 z",
    style: {
      fill: "#1b1768",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2314"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2316",
    transform: "matrix(0.14533662,0,0,-0.14321007,27.67527,12.98068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -3.237,-0.725 -6.479,-1.275 -9.718,-1.275 -9.71,0 -19.421,4.914 -29.129,4.914 h -0.013 c -9.71,0 -19.425,-4.914 -29.133,-4.914 -9.709,0 -19.42,4.914 -29.131,4.914 -10.415,0 -19.417,-4.914 -19.417,-4.914 v 9.837 c 0,0 9.707,4.916 19.417,4.916 9.711,0 19.422,-4.916 29.131,-4.916 9.708,0 19.369,4.911 29.133,4.916 9.773,-0.005 19.434,-4.916 29.142,-4.916 3.251,0 6.45,0.549 9.699,1.288 z",
    style: {
      fill: "#1b1768",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2318"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2320",
    transform: "matrix(0.14533662,0,0,-0.14321007,27.67527,15.618596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -3.237,-0.726 -6.479,-1.275 -9.718,-1.275 -9.71,0 -19.421,4.917 -29.129,4.917 h -0.013 c -9.71,0 -19.425,-4.917 -29.133,-4.917 -9.709,0 -19.42,4.917 -29.131,4.917 -10.415,0 -19.417,-4.917 -19.417,-4.917 V 8.56 c 0,0 9.707,4.918 19.417,4.918 9.711,0 19.422,-4.918 29.131,-4.918 9.708,0 19.369,4.913 29.133,4.918 9.773,-0.004 19.434,-4.918 29.142,-4.918 3.251,0 6.45,0.549 9.699,1.283 z",
    style: {
      fill: "#1b1768",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2322"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2324",
    transform: "matrix(0.14533662,0,0,-0.14321007,17.931177,0.14169744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 4.274,-12.187 14.897,-27.06 22.494,-37.174 5.799,-7.715 11.529,-17.043 11.529,-27.098 0,-46.911 -67.484,-46.556 -67.97,-1.072 -0.118,10.967 5.44,19.651 11.595,28.17 C -14.2,-25.887 -5.203,-13.094 0,0",
    style: {
      fill: "#006bb5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2326"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2328",
    transform: "matrix(0.14533662,0,0,-0.14321007,16.138883,11.986316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -3.369,-4.246 c 0,0 4.345,-2.831 9.603,-3.761 0,0 -2.832,2.293 -6.234,8.007",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path2330"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2332",
    transform: "matrix(0.14533662,0,0,-0.14321007,15.26829,6.3583317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 4.584,-4.422 c 0,0 -17.365,-13.801 -0.215,-32.712 L 0.875,-41.995 C -21.508,-20.432 0,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path2334"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2336",
    transform: "matrix(0.14533662,0,0,-0.14321007,36.548885,14.304672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 4.373 v 25.862 c -0.011,1.061 0.153,1.899 0.498,2.524 0.343,0.624 0.931,1.239 1.772,1.851 L 4.699,34.209 C 4.091,33.942 3.461,33.682 2.813,33.417 2.166,33.151 1.498,33.008 0.809,32.985 h -21.968 v -6.311 h 9.649 V 9.066 c -6.055,-0.063 -10.911,1.712 -14.564,5.332 -3.658,3.626 -5.534,9.501 -5.629,17.619 -0.027,1.032 0.047,2.464 0.212,4.292 0.167,1.833 0.586,3.712 1.248,5.648 0.663,1.931 1.729,3.571 3.193,4.913 1.465,1.343 3.481,2.044 6.055,2.103 1.434,0.003 2.696,-0.368 3.791,-1.113 1.091,-0.749 1.665,-1.891 1.723,-3.43 0.004,-0.573 -0.083,-1.131 -0.264,-1.663 -0.177,-0.537 -0.47,-1.007 -0.869,-1.421 l 3.001,-4.542 17.58,11.348 -3.403,5.032 -2.994,-1.943 c -2.091,1.428 -4.375,2.681 -6.851,3.746 -2.474,1.065 -5,1.626 -7.577,1.678 -6.07,-0.057 -11.533,-1.444 -16.39,-4.158 -4.856,-2.718 -8.715,-6.41 -11.572,-11.08 -2.859,-4.668 -4.321,-9.969 -4.385,-15.889 0.108,-8.253 2.485,-14.763 7.142,-19.535 4.655,-4.769 10.948,-7.204 18.876,-7.301 3.918,0.033 7.495,0.657 10.726,1.869 3.227,1.223 6.194,2.836 8.895,4.854 z",
    style: {
      fill: "#1b1768",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path2338"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2340",
    transform: "matrix(0.14533662,0,0,-0.14321007,37.767083,7.6862335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.026,-1.666 0.537,-2.919 1.538,-3.758 1,-0.845 2.318,-1.264 3.973,-1.266 1.399,-0.012 2.908,0.202 4.506,0.65 1.601,0.44 2.982,1.17 4.135,2.182 1.146,1.007 1.756,2.361 1.804,4.052 -0.08,2.055 -0.847,3.432 -2.298,4.131 C 12.212,6.69 10.574,7.014 8.749,6.963 7.546,6.949 6.275,6.645 4.93,6.041 3.591,5.435 2.447,4.611 1.493,3.568 0.539,2.524 0.039,1.333 0,0",
    style: {
      fill: "#fdd856",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path2342"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2344",
    transform: "matrix(0.14533662,0,0,-0.14321007,40.380861,14.304672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 4.855 H -2.678 V 41.016 L -20.419,35.99 v -4.623 l 2.92,0.57 V 4.855 h -3.084 V 0 Z",
    style: {
      fill: "#1b1768",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path2346"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2348",
    transform: "matrix(0.14533662,0,0,-0.14321007,43.860423,14.304672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 16.289 v 4.855 h -2.598 v 22.704 c -0.057,4.751 -1.434,8.189 -4.129,10.319 -2.697,2.13 -6.336,3.178 -10.937,3.138 -1.679,0.005 -3.358,-0.142 -5.032,-0.445 -1.674,-0.3 -3.276,-0.771 -4.79,-1.417 l 0.728,2.185 -4.854,1.624 -5.192,-14.105 5.028,-1.864 c 1.039,1.503 2.219,2.9 3.553,4.192 1.33,1.284 3.146,1.973 5.445,2.053 1.785,-0.014 3.128,-0.492 4.014,-1.426 0.899,-0.941 1.342,-2.251 1.342,-3.931 V 25.851 H -12.25 c -3.699,-0.019 -6.77,-1.303 -9.224,-3.84 -2.454,-2.541 -3.727,-6.18 -3.818,-10.913 0.074,-3.815 1.304,-6.806 3.676,-8.985 2.369,-2.181 5.44,-3.287 9.209,-3.332 2.293,0.033 4.37,0.512 6.247,1.45 1.866,0.936 3.623,2.119 5.269,3.573 z M -1.133,13.209 C -1.083,11.611 -1.361,10.238 -1.964,9.089 -2.568,7.939 -3.777,7.34 -5.6,7.282 -7.542,7.37 -8.846,8.094 -9.523,9.463 c -0.677,1.376 -0.99,2.893 -0.946,4.559 0.038,2.097 0.695,3.782 1.971,5.039 1.274,1.26 2.946,1.906 5.009,1.94 h 2.356 z",
    style: {
      fill: "#1b1768",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path2350"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2352",
    transform: "matrix(0.14533662,0,0,-0.14321007,49.455748,14.304672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 4.855 h -3.166 v 23.031 c 0.703,0.964 1.539,1.764 2.518,2.412 0.981,0.636 2.063,0.975 3.246,1.001 1.877,-0.003 3.196,-0.486 3.944,-1.442 0.755,-0.959 1.115,-2.368 1.083,-4.242 V 4.855 H 4.546 V 0 h 20.827 v 4.855 h -2.916 v 24.982 c 0.027,1.695 -0.278,3.388 -0.912,5.095 -0.629,1.702 -1.74,3.132 -3.339,4.285 -1.593,1.154 -3.829,1.751 -6.685,1.799 C 8.465,40.974 5.816,40.313 3.569,39.033 1.327,37.754 -0.915,36.12 -3.166,34.129 v 16.05 l 3.006,1.056 v 5.43 L -20.828,49.53 v -4.946 l 2.84,0.973 V 4.855 h -3.004 V 0 Z",
    style: {
      fill: "#1b1768",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path2354"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2356",
    transform: "matrix(0.14533662,0,0,-0.14321007,58.06581,9.0685534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -2.303,1.428 -4.579,2.524 -6.822,3.291 -2.243,0.77 -4.724,1.154 -7.437,1.162 -4.564,-0.016 -8.295,-1.274 -11.206,-3.765 -2.912,-2.494 -4.418,-6.095 -4.52,-10.822 0.107,-2.705 1.162,-4.944 3.166,-6.728 2.009,-1.784 4.328,-3.312 6.969,-4.585 2.641,-1.275 4.966,-2.501 6.97,-3.672 2.002,-1.178 3.062,-2.504 3.167,-3.995 -0.064,-0.603 -0.434,-1.166 -1.105,-1.688 -0.681,-0.517 -1.314,-0.79 -1.903,-0.825 -1.664,0.056 -3.348,0.671 -5.055,1.831 -1.692,1.159 -3.304,2.506 -4.813,4.046 -1.512,1.539 -2.815,2.904 -3.911,4.095 l -6.812,-10.379 c 2.337,-1.654 4.904,-3.018 7.694,-4.091 2.786,-1.063 5.656,-1.62 8.595,-1.656 3.028,-0.013 5.884,0.457 8.574,1.405 2.68,0.954 4.871,2.474 6.561,4.557 1.691,2.091 2.564,4.827 2.622,8.222 -0.104,3.264 -1.163,5.838 -3.167,7.701 -2.009,1.87 -4.331,3.384 -6.975,4.539 -2.631,1.149 -4.957,2.295 -6.962,3.42 -2.003,1.128 -3.062,2.584 -3.168,4.372 0.021,0.789 0.267,1.302 0.739,1.542 0.479,0.241 1.071,0.346 1.776,0.327 1.242,-0.056 2.531,-0.572 3.879,-1.542 1.344,-0.979 2.618,-2.084 3.822,-3.326 1.197,-1.242 2.2,-2.297 3.009,-3.164 z",
    style: {
      fill: "#1b1768",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path2358"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2360",
    transform: "matrix(0.14533662,0,0,-0.14321007,62.015438,14.304672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 16.289 v 4.855 h -2.601 v 22.704 c -0.056,4.751 -1.439,8.189 -4.126,10.319 -2.696,2.13 -6.344,3.178 -10.941,3.138 -1.68,0.005 -3.353,-0.142 -5.033,-0.445 -1.679,-0.3 -3.271,-0.771 -4.785,-1.417 l 0.725,2.185 -4.861,1.624 -5.184,-14.105 5.025,-1.864 c 1.033,1.503 2.222,2.9 3.558,4.192 1.33,1.284 3.145,1.973 5.445,2.053 1.784,-0.014 3.117,-0.492 4.012,-1.426 0.896,-0.941 1.342,-2.251 1.342,-3.931 v -2.031 h -11.117 c -3.699,-0.019 -6.774,-1.303 -9.222,-3.84 -2.456,-2.541 -3.728,-6.18 -3.817,-10.913 0.071,-3.815 1.297,-6.806 3.672,-8.985 2.373,-2.181 5.444,-3.287 9.202,-3.332 2.292,0.033 4.38,0.512 6.249,1.45 1.87,0.936 3.631,2.119 5.277,3.573 z M -1.135,13.209 C -1.091,11.611 -1.36,10.238 -1.97,9.089 -2.569,7.939 -3.782,7.34 -5.599,7.282 -7.544,7.37 -8.854,8.094 -9.522,9.463 c -0.679,1.376 -0.993,2.893 -0.95,4.559 0.041,2.097 0.699,3.782 1.976,5.039 1.271,1.26 2.936,1.906 5.004,1.94 h 2.357 z",
    style: {
      fill: "#1b1768",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path2362"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 29.701773,15.212409 h 34.681093 v 0.588737 H 29.701773 Z",
    style: {
      fill: "#fdd856",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0.14427
    },
    id: "path2364"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.e340e174.svg";
export { ForwardRef as ReactComponent };